import { observer } from 'mobx-react-lite';
import React from 'react';
import { mergeSx } from '@jucy-ui/appearance';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { bookingSummaryState } from '../BookingSummaryContext';

export interface SummaryPanelRowProps {
    title?: React.ReactNode;
    subTitle?: React.ReactNode;
    value?: React.ReactNode;
    isAlwaysShowPrice?: boolean;
    isPaymentDetails?: boolean;
    sx?: SxProps<Theme>;
}

const BookingSummaryPanelRow: React.FC<React.PropsWithChildren<SummaryPanelRowProps>> = observer(function BookingSummaryPanelRowComponent({
    title,
    sx,
    subTitle,
    value,
    isAlwaysShowPrice,
    isPaymentDetails,
}) {
    const isShowingPrice = !bookingSummaryState.isPartnerBooking || isAlwaysShowPrice;

    return (
        <Stack
            direction="row"
            sx={mergeSx(
                {
                    justifyContent: 'space-between',
                    mb: 1,
                },
                sx
            )}
        >
            <Box>
                <Typography variant="caption" component="div">
                    {title}
                </Typography>
                {isShowingPrice && subTitle ? (
                    <Typography variant="caption" component="div">
                        {subTitle}
                    </Typography>
                ) : null}
            </Box>
            <Typography
                variant="caption"
                component="div"
                sx={{
                    fontWeight: '700',
                    textAlign: 'right',
                }}
            >
                {isPaymentDetails ? value : value && isShowingPrice ? value : null}
            </Typography>
        </Stack>
    );
});

export default BookingSummaryPanelRow;
